/**
 * "+15551234567" → "+1 (555) 123-4567". Anything that isn't a NANP number is
 * returned unchanged.
 */
export function formatPhoneNumber(value: string): string {
  const match = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(value.replace(/\s/g, ""));
  return match ? `+1 (${match[1]}) ${match[2]}-${match[3]}` : value;
}
